export default __webpack_public_path__ + "static/media/imagem_01.7525e23a.png";